<script lang="ts">
  import { searchStore } from "/@/stores/SearchStore"
  import { createForm } from "@tastyworks/svelte-forms-lib"
  import type { AdminCustomerAccountParams } from "@tastyworks/tastyworks-api"
  import { Button, Input, Label } from "@tastyworks/ui-library"

  type Props = {
    onSearchCustomers: (params: AdminCustomerAccountParams) => void
    onResetCustomers: () => void
  }
  const { onSearchCustomers, onResetCustomers }: Props = $props()

  const { form, handleSubmit } = createForm({
    initialValues: {
      accountNumber: "",
      firstName: "",
      lastName: "",
      login: "",
      phoneNumber: "",
      taxNumber: "",
    },
    onSubmit: (values) => {
      onSearchCustomers({
        accountNumber: values.accountNumber || undefined,
        firstName: values.firstName || undefined,
        lastName: values.lastName || undefined,
        login: values.login || undefined,
        partialNameSearch: true,
        phoneNumber: values.phoneNumber || undefined,
        taxNumber: values.taxNumber || undefined,
      })
    },
  })

  function handleFormReset() {
    searchStore.reset()
    form.set({
      accountNumber: "",
      firstName: "",
      lastName: "",
      login: "",
      phoneNumber: "",
      taxNumber: "",
    })
    onResetCustomers()
  }

  function sanitizeInput(input: string) {
    return input.replace(/\s/g, "")
  }

  function sanitizePhoneNumber(input: string) {
    return sanitizeInput(input).replace(/[^\d+]/g, "")
  }

  function handleInput(event: InputEvent, dataName: keyof typeof $form) {
    event.preventDefault()
    const target = event.target as HTMLInputElement
    const value = target.value

    switch (dataName) {
      case "phoneNumber":
        $form[dataName] = sanitizePhoneNumber(value)
        break
      default:
        $form[dataName] = sanitizeInput(value)
        break
    }
  }
</script>

<div class="flex flex-col items-center border-b-2 border-black">
  <form class="flex gap-2 pb-3" onsubmit={handleSubmit}>
    <div class="grid grid-cols-4 grid-rows-2 items-end gap-2">
      <div class="flex flex-col gap-1">
        <Label class="w-full truncate text-nowrap pl-3" for="phoneNumber"
          >Phone Number</Label
        >
        <Input
          id="phoneNumber"
          name="phoneNumber"
          type="search"
          bind:value={$form.phoneNumber}
          oninput={(event) => handleInput(event, "phoneNumber")}
        />
      </div>
      <div class="flex flex-col gap-1">
        <Label class="w-full truncate text-nowrap pl-3" for="accountNumber"
          >Account Number</Label
        >
        <Input
          id="accountNumber"
          name="accountNumber"
          type="search"
          bind:value={$form.accountNumber}
          oninput={(event) => handleInput(event, "accountNumber")}
        />
      </div>
      <div class="flex flex-col gap-1">
        <Label class="w-full truncate text-nowrap pl-3" for="taxNumber"
          >Tax Number</Label
        >
        <Input
          id="taxNumber"
          name="taxNumber"
          type="search"
          placeholder="SSN, EIN, ITIN"
          bind:value={$form.taxNumber}
        />
      </div>
      <div class="flex flex-col gap-1">
        <Label class="w-full truncate text-nowrap pl-3" for="login">Login</Label
        >
        <Input
          id="login"
          name="login"
          type="search"
          placeholder="Email, Username, Nickname"
          bind:value={$form.login}
          oninput={(event) => handleInput(event, "login")}
        />
      </div>
      <div class="flex flex-col gap-1">
        <Label class="w-full truncate text-nowrap pl-3" for="firstName"
          >First Name</Label
        >
        <Input
          id="firstName"
          name="firstName"
          type="search"
          bind:value={$form.firstName}
        />
      </div>
      <div class="flex flex-col gap-1">
        <Label class="w-full truncate text-nowrap pl-3" for="lastName"
          >Last Name</Label
        >
        <Input
          id="lastName"
          name="lastName"
          type="search"
          bind:value={$form.lastName}
        />
      </div>
      <Button
        name="clear"
        variant="cancel"
        type="reset"
        onclick={handleFormReset}>Clear</Button
      >
      <Button name="search" variant="confirmation" type="submit">Search</Button>
    </div>
  </form>
</div>
